export type ArrowIconProps = {
  color?: string;
};

export default function ArrowIcon({ color }: ArrowIconProps) {
  const fill = color || "none";
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.5 15.6101C18.32 15.6101 18.14 15.5401 17.99 15.4101L12 9.89008L6.01003 15.4201C5.71003 15.7001 5.23003 15.6801 4.95003 15.3801C4.67003 15.0801 4.69004 14.6001 4.99004 14.3201L10.98 8.79008C11.55 8.26008 12.44 8.26008 13.02 8.79008L19.01 14.3201C19.31 14.6001 19.33 15.0801 19.05 15.3801C18.9 15.5301 18.7 15.6101 18.5 15.6101Z" fill={fill}/>
    </svg>
  );
}
